"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _Lightbulb = _interopRequireDefault(require("@honeybook/icons/dist/icons/Lightbulb24"));
var _react = _interopRequireWildcard(require("react"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HBContextualTooltip = require("./HBContextualTooltip.styles");
var _HBButton = _interopRequireDefault(require("../HBButton/HBButton"));
var _HBCloseButton = _interopRequireDefault(require("../HBCloseButton/HBCloseButton"));
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
var _lodash = require("lodash");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var HBContextualTooltip = function HBContextualTooltip(_ref) {
  var title = _ref.title,
    description = _ref.description,
    joyrideProps = _ref.joyrideProps,
    horizontalOffset = _ref.horizontalOffset,
    verticalOffset = _ref.verticalOffset,
    hideCloseButton = _ref.hideCloseButton,
    preventClickOutside = _ref.preventClickOutside,
    ctaText = _ref.ctaText,
    width = _ref.width,
    onCTAClick = _ref.onCTAClick,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'dark' : _ref$theme;
  var tooltipProps = joyrideProps.tooltipProps,
    onCloseClick = joyrideProps.skipProps.onClick,
    onNextClick = joyrideProps.primaryProps.onClick;
  var handleUserKeyPress = (0, _react.useCallback)(function (event) {
    var key = event.key;
    if (key === 'Enter') {
      onNextClick(event);
    }
  }, [onNextClick]);
  var handleUserMouseClick = (0, _react.useCallback)(function (event) {
    var tooltipElement = document.querySelector('#tooltip_container');
    if (!tooltipElement.contains(event.target) && !preventClickOutside) {
      onCloseClick(event);
    }
  }, [onCloseClick, preventClickOutside]);
  (0, _react.useEffect)(function () {
    window.addEventListener('keydown', handleUserKeyPress);
    return function () {
      window.removeEventListener('keydown', handleUserKeyPress);
    };
  }, [handleUserKeyPress]);
  (0, _react.useEffect)(function () {
    window.addEventListener('mouseup', handleUserMouseClick);
    return function () {
      window.removeEventListener('mouseup', handleUserMouseClick);
    };
  }, [handleUserMouseClick]);
  var isDark = theme === 'dark';
  var textColor = isDark ? 'white' : 'textPrimary';
  var LightbulbElement = isDark ? /*#__PURE__*/_react["default"].createElement(_Lightbulb["default"], {
    color: _colors["default"].white
  }) : /*#__PURE__*/_react["default"].createElement(_Lightbulb["default"], {
    color: _colors["default"].neutral900
  });
  return /*#__PURE__*/_react["default"].createElement(_HBContextualTooltip.ContextualContainer, (0, _extends2["default"])({}, tooltipProps, {
    width: width,
    verticalOffset: verticalOffset,
    horizontalOffset: horizontalOffset,
    $backgroundColor: isDark ? _colors["default"].contextualBlue : _colors["default"].white,
    id: "tooltip_container"
  }), !hideCloseButton && /*#__PURE__*/_react["default"].createElement(_HBCloseButton["default"], {
    size: "xs",
    distance: 8,
    theme: isDark ? 'light' : 'dark',
    onClick: onCloseClick,
    testId: "contextual-tooltip-close"
  }), /*#__PURE__*/_react["default"].createElement(_HBContextualTooltip.ContextualContentWrapper, null, LightbulbElement, /*#__PURE__*/_react["default"].createElement(_HBContextualTooltip.ContextualTextWrapper, null, title && /*#__PURE__*/_react["default"].createElement(_HBText["default"], {
    type: "emphasis16",
    color: textColor
  }, title), /*#__PURE__*/_react["default"].createElement(_HBContextualTooltip.ContextualDescription, {
    type: "body14",
    color: textColor
  }, description))), ctaText && /*#__PURE__*/_react["default"].createElement(ButtonContainer, null, /*#__PURE__*/_react["default"].createElement(StyledHBButton, {
    buttonTheme: "primary-blue",
    onClick: (0, _lodash.isFunction)(onCTAClick) ? onCTAClick(joyrideProps) : onCloseClick,
    testId: "tooltip-cta--button"
  }, ctaText)));
};
var _default = exports["default"] = HBContextualTooltip; // -------------------------------- Styles -------------------------------- //
var ButtonContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBContextualTooltip__ButtonContainer",
  componentId: "sc-1407mws-0"
})(["display:flex;justify-content:flex-end;margin-top:10px;"]);
var StyledHBButton = (0, _styledComponents["default"])(_HBButton["default"]).withConfig({
  displayName: "HBContextualTooltip__StyledHBButton",
  componentId: "sc-1407mws-1"
})(["font-size:14px;height:auto;padding:10px 12px;"]);
//# sourceMappingURL=HBContextualTooltip.js.map